'use client';

import { type ChangeEvent } from 'react';

import { Caption } from '@depop/web-thrift-ui/Typography';
import { Input } from '@depop/web-ui-kit/Input';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import {
  type DisplayPriceElement,
  type HeadlinePriceComponents,
} from '@/modules/price/aliases';
import { getHeadlineDescriptionKey } from '@/modules/price/helpers/displayPriceRules';

type Props = {
  offerPrice: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  currencySymbol: string;
  errorText?: string;
  isLoading?: boolean;
  labelText: string;
  placeholder: string;
  quote?: DisplayPriceElement;
  quotePriceComponents?: HeadlinePriceComponents;
};

export function OfferModalInput({
  currencySymbol,
  errorText,
  isLoading,
  labelText,
  offerPrice,
  onChange,
  placeholder,
  quote,
  quotePriceComponents,
}: Props) {
  const tOffers = useTranslations('offers');
  const captionKey = getHeadlineDescriptionKey(quotePriceComponents);

  return (
    <>
      <div className={styles.inputWrapper}>
        <Input
          type="number"
          id="offerModalInput"
          labelText={labelText}
          leadingText={currencySymbol}
          value={offerPrice}
          isClearable={false}
          onChange={onChange}
          errorText={errorText}
          placeholder={placeholder}
          isLoading={isLoading}
        />
      </div>
      {quote && captionKey && (
        <Caption
          variant="lg-regular"
          className={styles.totalOfferPriceWithFeeQuote}
          // eslint-disable-next-line no-restricted-syntax
          data-testid="offerModalInput__includingFees"
        >
          {currencySymbol} {quote.amount} {tOffers(captionKey)}
        </Caption>
      )}
    </>
  );
}
